const header_summary = document.querySelectorAll(".header nav summary");
const old_details = document.querySelectorAll(".header nav details");

header_summary.forEach((item) => {
  item.addEventListener("mouseenter", (event) => {
    if(window.innerWidth > 989) {
      hiddenHeaderMadal();

      const target = event.currentTarget;
      const details = target.closest("details");

      if (details) {
        details.open = true;
      }
    }
  });
});

const mega_menu__content = document.querySelectorAll(
  ".header .mega-menu__content",
);

mega_menu__content.forEach((item) => {
  item.addEventListener("mouseleave", () => hiddenHeaderMadal());
});

function hiddenHeaderMadal() {
  old_details.forEach((item) => (item.open = false));
}

function insertPRSearch() {
  const prsearch_template = document.getElementById("prsearch-content");
  const prsearch_box = document.getElementById("prsearch-content-box");

  if (!prsearch_template || !prsearch_box) return;

  const clone = prsearch_template.content.cloneNode(true);
  prsearch_box.innerHTML = "";
  prsearch_box.appendChild(clone);
}
window.insertPRSearch = insertPRSearch;
insertPRSearch();

function loadSwiperElements() {
  let initialized = false;

  const interval = setInterval(() => {
    const elems = document.querySelectorAll(".search-slider");

    if (elems.length > 0 && !initialized) {
      initialized = true;
      swiperInit(elems);
      clearInterval(interval);

      window.addEventListener('resize', () => {
        swiperInit(elems);
      });
    }
  }, 50);

  setTimeout(() => clearInterval(interval), 15000);
}

window.loadSwiperElements = loadSwiperElements;
loadSwiperElements();

function swiperInit(elems) {
  elems.forEach((el) => {
    const isDesktop = window.innerWidth > 1024;
    const initialized = el.dataset.swiperInit === "true";

    if (isDesktop && !initialized) {
      const swiper = new Swiper(el, {
        slidesPerView: 4,
        spaceBetween: 11,
        navigation: {
          nextEl: el.querySelector(".swiper-button-next"),
          prevEl: el.querySelector(".swiper-button-prev"),
        },
      });

      el.swiperInstance = swiper;
      el.dataset.swiperInit = "true";
      return;
    }

    if (!isDesktop && initialized) {
      if (el.swiperInstance && el.swiperInstance.destroy) {
        el.swiperInstance.destroy(true, true);
      }

      el.swiperInstance = null;
      el.dataset.swiperInit = "false";
      return;
    }
  });
}

const searchResetButton = document.querySelector(".search-modal__close-button");

if (searchResetButton) {
  searchResetButton.addEventListener("click", () => {
    closeSearchModal();
    document.body.classList.remove('overflow-hidden');
  });
}

function closeSearchModal() {
  const detailsModal = document.querySelector(
    "details-modal.header__search details",
  );
  if (detailsModal) {
    detailsModal.open = false;
  }
}
